import { authentication } from "../configs";

export const getUserId = async () => {
  await new Promise((resolve) => authentication.onAuthStateChanged(resolve));
  return authentication.currentUser?.uid;
};
